module.exports = __webpack_public_path__ + "a2d7c7ed090fe730cd0ed8ef56993c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star_white_active_2x.png
// module id = 130
// module chunks = 0 1 2 3 4